var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_admin_punchRecord_list_title"),
      pad: "0",
      filterable: "",
    },
    on: {
      activated: _vm.activated,
      filter: function (val) {
        _vm.filterPageData = val
      },
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(1, filter)
                },
                update: function (prop, value, selected) {
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(1, filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275 - 48,
                totalCount: _vm.totalCount,
                "filter-page-data": _vm.filterPageData,
                overLoading: "",
              },
              on: {
                change: function (page, perpage, callback, data) {
                  _vm.getList(data, page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "div",
                        { staticStyle: { "max-width": "300px" } },
                        [
                          _c(
                            "v-list-item",
                            {
                              staticClass: "pa-0",
                              attrs: { dense: "", "two-line": "" },
                            },
                            [
                              _c(
                                "v-list-item-avatar",
                                {
                                  staticClass: "mr-1 my-0",
                                  attrs: { size: "36" },
                                },
                                [
                                  _c("StaffAvatar", {
                                    attrs: {
                                      size: "36",
                                      src: item.staff_avatar,
                                      staff_name: item.preferred_name,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "text--primary" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$getCommonLangValue(
                                              item.preferred_name
                                            )
                                          ) +
                                          " "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text--secondary text-caption-xs",
                                        },
                                        [_vm._v(" " + _vm._s(item.staff_code))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "text--secondary" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$getCommonLangValue(
                                            item.job_post_name
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "item.date",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(
                              item.punch_utc_datetime,
                              "YYYY/MM/DD"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.site_name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$getCommonLangValue(item.site_name)) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.time",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$getDateTime(item.punch_utc_datetime, "HH:mm")
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: "item.criteria",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "div",
                                      _vm._g({}, on),
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "transparent",
                                            iconClass: Number(
                                              item.punch_criteria_matched
                                            )
                                              ? "Done"
                                              : "Alert",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                Number(item.punch_criteria_matched)
                                  ? _vm.$t(
                                      "message_essweb_punchRecord_list_tip_criteriaMatchedLabel"
                                    )
                                  : _vm.$t(
                                      "message_essweb_punchRecord_list_tip_criteriaNotMatchedLabel"
                                    )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.source",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(
                          item.source === null
                            ? ""
                            : Number(item.source) == 0
                            ? _vm.$t("label_essweb_punchRecord_list_appLabel")
                            : Number(item.source) == 1
                            ? _vm.$t("label_essweb_punchRecord_list_dkjLabel")
                            : ""
                        )
                      ),
                    ]
                  },
                },
                {
                  key: "item.tag",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      Number(item.is_work_from_home)
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "mr-1 white--text",
                              attrs: {
                                small: "",
                                color: _vm.$getTagColors(
                                  _vm.$card_line_colors,
                                  "is_work_from_home_1"
                                ),
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                  )
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                      Number(item.is_out_of_office)
                        ? _c(
                            "v-chip",
                            {
                              staticClass: "mr-1 white--text",
                              attrs: {
                                color: _vm.$getTagColors(
                                  _vm.$card_line_colors,
                                  "is_out_of_office_1"
                                ),
                                small: "",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_punchRecord_list_tag_fieldServiceLabel"
                                  )
                                )
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm.hasBtn("view-admin-clock-in-record")
                        ? _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.toView(item.uuid)
                                },
                              },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  size: "24",
                                  fill: "currentColor",
                                  iconClass: "viewDetail",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("viewPuchRecord", {
              attrs: { show: _vm.showDetail, curUuid: _vm.curUuid },
              on: {
                close: function ($event) {
                  _vm.showDetail = false
                  _vm.curUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }